import { MyEarningsProps } from '@/features/earn/components/portfolio/myEarnings/MyEarnings';
import { useMyEarnings } from '@/features/earn/components/portfolio/myEarnings/useMyEarnings.hook';
import { OverviewProps } from '@/features/earn/components/portfolio/overview/Overview';
import { useOverview } from '@/features/earn/components/portfolio/overview/useOverview.hook';
import { PositionsProps } from '@/features/earn/components/positions/Positions.web';
import { formatAmountByDecimals } from '@/utils/numberFormatting';
import { useStore } from 'store/store';

import { usePortfolioStyle } from './usePortfolioStyle.hook';
import { usePositions } from './usePositions.hook';

export const usePortfolio = () => {
  const store = useStore();
  const { layoutStyle } = usePortfolioStyle();
  const overview = useOverview({});
  const positions = usePositions({});
  const myEarnings = useMyEarnings({});

  function refresh() {
    positions.handleRefresh();
  }

  function refreshPortfolio() {
    overview.query.refetch();
    positions.query.refetch();
    myEarnings.query.refetch();
  }

  const overviewProps: OverviewProps = {
    data: overview.data,
    lastUpdated: overview.lastUpdated,
    netAssetValue: overview.netAssetValue,
    currency: overview.currency,
    loading: overview.loading,
    breakdown: overview.breakdown,
    onChangeCurrency: overview.onChangeCurrency
  };

  const positionsProps: PositionsProps = {
    data: positions.data || [],
    loading: positions.query.isLoading || positions.query.isFetching,
    paginatedProps: {
      currentPage: positions.paginationProps.current,
      totalPages: positions.totalPages,
      onNextPage: positions.handleNextPage,
      onPrevPage: positions.handlePrevPage
    },
    onUpdate: refresh,
    onFilterChange: positions.onFilterChange,
    refreshPortfolio
  };

  const myEarningsProps: MyEarningsProps = {
    overview: myEarnings.overview,
    barChartData: myEarnings.barChartData.map((item) => ({
      ...item,
      tooltipText: formatAmountByDecimals({ value: item.value, decimals: 2, suffix: overview.currency })
    })),
    showAmount: store.showAmount,
    currency: myEarnings.currency,
    loading: myEarnings.loading,
    analyticRange: myEarnings.analyticRange,
    changeDateRange: myEarnings.changeDateRange
  };

  return {
    stakingList: positions.data,
    layoutStyle,
    overviewProps,
    positionsProps,
    myEarningsProps,
    refresh,
    refreshPortfolio
  };
};
